import { FC, Fragment } from 'react';

import { ImagesApp } from '../../constants/images';
import { useEventContext } from '../../hooks/contexts/event.context';
import { useI18nContext } from '../../hooks/contexts/i18n.context';
import FanMember from '../IdentifyMember';
import * as Styles from './noTickets.styles';

const EmptyState: FC = () => {
  const { translate } = useI18nContext();
  const { eventNotFound, isFootball, ticketListError } = useEventContext();

  const genericDictionary = {
    image : ImagesApp.svg.emptyTickets,
    title : translate(['INFORMATION', 'NO_TICKETS']),
    subtitle : translate(['INFORMATION', 'MORE_INFORMATION']),
  };

  const eventNotFoundDictionary = {
    ...genericDictionary,
    title : translate(['INFORMATION', 'EVENT_NOT_FOUND']),
  };

  const footballDictionary = {
    ...genericDictionary,
    image : ImagesApp.svg.emptyTicketsFutebol,
    title : translate(['INFORMATION', 'NO_TICKETS_FUTEBOL']),
    subtitle : translate(['INFORMATION', 'MORE_INFORMATION_FUTEBOL']),
  };

  const ticketListErrorDictionary = {
    ...genericDictionary,
    title : translate(['INFORMATION', 'ERROR_EMPTY_TICKET_LIST_TITLE']),
    subtitle : translate(['INFORMATION', 'ERROR_EMPTY_TICKET_LIST_SUBTITLE']),
  };

  const handleDictionary = () => {
    let expectedDictionary = { ...genericDictionary };

    if (isFootball) expectedDictionary = { ...footballDictionary };
    if (eventNotFound) expectedDictionary = { ...eventNotFoundDictionary };
    if (ticketListError) expectedDictionary = { ...ticketListErrorDictionary };

    return expectedDictionary;
  };

  return (
    <Fragment>
      {isFootball && <FanMember size="30%" />}
      <Styles.NoTickets
        $reduceHeight={isFootball}
        id="empty-state-no-tickets"
      >
        <Styles.Image src={handleDictionary().image} alt="No tickets" id="empty-state-image" />
        <Styles.Title id="empty-state-title">
          {handleDictionary().title}
        </Styles.Title>
        <Styles.Subtitle id="empty-state-subtitle">
          {handleDictionary().subtitle}
        </Styles.Subtitle>
      </Styles.NoTickets>
    </Fragment>
  );
};

export default EmptyState;
